const defaultState = {
  focusedOption: null,
  focusedTag: null,
  performTagUnfocus: false,
  focusInput: false,
  blurInput: false,
  optionsClosed: true,
  input: {
    value: ''
  }
}

export default defaultState
